// import React
import React, { useState } from "react";

//import validator
import validator from "validator";

// import Firebase
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

// import Components
import NavigationBar from "../Components/NavigationBar";
import Footer from "../Components/Footer";

// import CSS
import "./Contact.css";

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !email || !message) {
      setError("Please fill out all fields.");
      console.log(error);
      return;
    }

    if (validator.isEmail(email)) {
      const messageData = {
        content: `Name: ${name}\nEmail: ${email}\n\nMessage: ${message}`,
      };
      const webhook = process.env.REACT_APP_DISCORD_WEBHOOK;

      const postToDiscord = httpsCallable(functions, "postToDiscord");
      try {
        const result = await postToDiscord({
          message: messageData,
          webhook: webhook,
        });
        console.log(result.data);
        setName("");
        setEmail("");
        setMessage("");
        setError("");
      } catch (err) {
        setError(err);
        console.log(error);
      }
    } else {
      setError("Please enter a valid email address.");
      console.log(error);
    }
  };

  return (
    <div className='contact-container'>
      <NavigationBar />
      <div className='contact-form-container'>
        <img
          src='/images/overload_logo_white.png'
          alt='Overload Events Logo'
          className='overload-events-logo'
        />
        <div className='contact-header'>Contact Us</div>
        <form
          className='contact-form'
          onSubmit={(e) => {
            handleSubmit(e);
          }}>
          {" "}
          <input
            type='text'
            className={`name-input ${error && !name ? "error" : ""}`}
            placeholder='Name'
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <input
            type='text'
            className={`email-input ${error && !email ? "error" : ""}`}
            placeholder='Email'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <textarea
            className={`message-input ${error && !message ? "error" : ""}`}
            placeholder='Message'
            rows='5'
            cols='50'
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <button className='submit-button'>Send</button>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
